import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Col, Container, Row} from "mdbreact";
import MerchantsCat from "./MerchantsCat";
import {API_URL} from "./../../config/Config";
import { ToastContainer } from 'react-toastify';
import {Link} from "react-router-dom";
import MostPopularMerchant from "./MostPopularMerchant";
import SectionLoader from "../loader/SectionLoader";
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });

class MerchantsCatList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            populars:[],
            selectedCat: 0,
            loading1:false,
            loading2:false,
        };
    }
    async componentDidMount() {
        await this.getMerchantCategory();
        await this.getMostPopulars();

    }

    async getMerchantCategory() {
        try {
            let response = await axios.get(`${API_URL}merchants-category`);
            let categories = await response.data.data;
            this.setState({categories});
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
            }
        }
        this.setState({loading1: true});
    }

    async getMostPopulars() {
        try {
            let response = await axios.get(`${API_URL}merchant-popular`);
            let populars = await response.data.data;
            this.setState({populars});
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
            }
        }
        this.setState({loading2: true});
    }

    render() {
        return <Container className="text-center rtl">
            <Row className="py-4 d-flex justify-content-center">
                <Col xs="12" md="10" lg="8" className="text-center">
                    {!this.state.loading1 ?
                        <SectionLoader type="spinningBubbles" color="#f6581d" />
                        :
                        <Row>
                            {this.state.categories.map(cat =>
                                <MerchantsCat key={cat.id} name={cat.name} catId={cat.id} image={cat.image_url}/>
                            )}
                        </Row>
                    }

                </Col>
            </Row>
            <ToastContainer
                hideProgressBar={true}
                newestOnTop={true}
                autoClose={3000}
            />
            <div className="clearfix"></div>
            <Row className="mt-5 py-1 justify-content-center">
                <h2 className="text-center underline">انتخاب های شما</h2>
            </Row>
            <Row className="justify-content-center">
                <p className="text-center">از محل های محبوب تر بازدید کنید</p>
            </Row>


            {!this.state.loading2 ?
                <SectionLoader type="spinningBubbles" color="#f6581d" />
                :
                <Row className="no-gutters mt-5 mb-3">
                    {this.state.populars.map(pop =>
                        <MostPopularMerchant key={pop.id} cover={pop.cover} logo={pop.logo} name={pop.name} alias={pop.alias} id={pop.id}/>
                    )}
                </Row>
            }

            <Row className="mt-2 pb-5 justify-content-center">
                <Link to="merchantList" className="btn btn-outline-warning waves-effect font-weight-bold">مشاهده همه مراکز طرف قرارداد ما</Link>
            </Row>
    </Container>

    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps,)(MerchantsCatList);


// WEBPACK FOOTER //
// ./src/components/merchants/MerchantsCatList.js